import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { setStationVerified } from "./adminApi";
import { VERIFICATION_QUEUE_KEY } from "./hooks";

type Props = {
  stationId: string;
  verified: boolean;
};

export function AdminVerifyToggle({ stationId, verified }: Props) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (next: boolean) => setStationVerified(stationId, next),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["station", stationId] });
      queryClient.invalidateQueries({ queryKey: VERIFICATION_QUEUE_KEY });
    },
  });

  return (
    <div data-testid="admin-verify-toggle" className="rounded-lg border border-ember/40 bg-ember/5 p-4">
      <button
        type="button"
        onClick={() => mutation.mutate(!verified)}
        disabled={mutation.isPending}
        className="rounded-md bg-ember-deep px-3 py-1 text-sm font-medium text-fg hover:bg-ember disabled:opacity-50"
      >
        {verified ? t("admin.unverify_station") : t("admin.verify_station")}
      </button>
      {mutation.isError && (
        <p className="mt-1 text-xs text-ember">{t("admin.verify_failed")}</p>
      )}
    </div>
  );
}
